import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=3eb4de80&scoped=true&"
import script from "./ArticleDetail.vue?vue&type=script&lang=ts&"
export * from "./ArticleDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&id=3eb4de80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb4de80",
  null
  
)

export default component.exports